import { Chip, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';

import { FILL_LATER_TYPE_LABEL, FILL_LATER_TYPE_TOOLTIP } from '../constants/fillLaterEligibility';

// Outlined rather than the status chip's soft fill: the two sit in the same row and the status is
// the one that changes over a row's life, so the type reads as a label beside it instead of
// competing with it for the same attention.
const TYPE_TONE = {
  SPLIT_BY_QUANTITY: (theme) => theme.palette.info.dark,
  SOURCE_BY_ORDER: (theme) => theme.palette.secondary.main,
  SOURCE_BY_ITEM: (theme) => theme.palette.primary.main,
};

const FillLaterQueueTypeChip = ({ fillLaterType }) => {
  // A row with no type can only be a historical one the backfill could not place; an em dash says
  // "not recorded" where an empty cell would read as a rendering fault.
  if (!fillLaterType || !FILL_LATER_TYPE_LABEL[fillLaterType]) return <span>&mdash;</span>;

  return (
    <Tooltip title={FILL_LATER_TYPE_TOOLTIP[fillLaterType] ?? ''} arrow>
      <Chip
        label={FILL_LATER_TYPE_LABEL[fillLaterType]}
        size='small'
        variant='outlined'
        data-testid={`fill-later-type-${fillLaterType}`}
        sx={(theme) => {
          const fg = (TYPE_TONE[fillLaterType] ?? TYPE_TONE.SPLIT_BY_QUANTITY)(theme);
          return {
            fontWeight: 500,
            color: fg,
            borderColor: alpha(fg, 0.4),
            bgcolor: alpha(fg, 0.06),
          };
        }}
      />
    </Tooltip>
  );
};

FillLaterQueueTypeChip.propTypes = {
  fillLaterType: PropTypes.string,
};

FillLaterQueueTypeChip.defaultProps = {
  fillLaterType: null,
};

export default FillLaterQueueTypeChip;
